export const CgnPhoneControl = new RegExp(
    /^(((0))[0-9]{10})$/i
  );
